import React from 'react';
import { Button } from './Button';
import { useCountdown } from '../hooks/useCountdown';
import { Lock } from 'lucide-react';
export function FooterCTA() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <footer className="bg-navy-900 pt-12 pb-8 px-4 border-t border-navy-800" data-id="element-30">
      <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-31">
        <p className="text-brand-red font-mono text-2xl font-bold mb-3" data-id="element-32">
          {hours}:{minutes}:{seconds}
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-33">
          Non perdere questa opportunità!
        </h2>
        <Button isDirectCheckout className="w-full md:w-auto text-xl px-10 py-5 mb-4" data-id="element-34">
          ACQUISTA ORA
        </Button>
        <div className="flex items-center justify-center gap-2 text-gray-500 text-xs" data-id="element-35">
          <Lock className="w-3.5 h-3.5" data-id="element-36" />
          <span data-id="element-37">Pagamento Sicuro · Garanzia 30gg · Accesso Immediato</span>
        </div>
      </div>

      <div className="max-w-4xl mx-auto border-t border-navy-800 pt-6 text-center text-xs text-gray-600 space-y-3" data-id="element-38">
        <div className="flex justify-center gap-4" data-id="element-39">
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-40">
            Termini e Condizioni
          </a>
          <span data-id="element-41">·</span>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-42">
            Privacy Policy
          </a>
          <span data-id="element-43">·</span>
          <a href="mailto:info@activapleno.com" className="text-gold-400 hover:underline" data-id="element-44">
            info@activapleno.com
          </a>
        </div>
        <p data-id="element-45">
          Disclaimer: Prodotto digitale. Accesso immediato dopo il pagamento.
        </p>
        <p data-id="element-46">
          © 2026 Activa Pleno. Tutti i diritti riservati. Questo sito non è
          affiliato a Facebook Inc.
        </p>
      </div>
    </footer>;
}